<template>
  <div class="d-flex align-items-start flex-column">
    <b-form-checkbox
      :id="`device-${device.id}`"
      :name="`device-${device.id}`"
      :disabled="localLoading"
      :checked="device.status === 'ARMED'"
      switch
      @change="handleToggle"
      v-if="isVisible"
      class="mb-1"
    >
      {{ titleAction(device.status) }}
    </b-form-checkbox>

    <!-- Modo mantenimiento -->
    <div class="d-flex align-items-center">
      <b-form-checkbox
        :id="`maintenance-area-${device.id}`"
        :checked="maintenanceValue"
        :disabled="!canSelectMaintenance"
        :title="canSelectMaintenance ? null : 'Falta el ID de dispositivo del área o de alguna zona'"
        switch
        class="maintenance-check"
        @change="onMaintenanceChange"
      >
        <small>Modo mantenimiento</small>
      </b-form-checkbox>
      <b-badge
        v-if="totalZoneCount > 0"
        :variant="maintenanceZoneCount > 0 ? 'primary' : 'light-secondary'"
        class="ml-50 mb-50"
      >
        {{ maintenanceZoneCount }} / {{ totalZoneCount }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { useDeviceMessages } from "@/views/dmp/dmp_panels/devices/composables/useDeviceMessages";
import axios from "@axios";
import { useUtils as useAclUtils } from "@core/libs/acl";

export default {
  name: "DmpArea",
  props: {
    device: Object,
    trans: Object,
    loadingToast: Object,
    updateStatus: Function,
    maintenanceValue: {
      type: Boolean,
      default: false,
    },
    maintenanceZoneCount: {
      type: Number,
      default: 0,
    },
    totalZoneCount: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const { confirmActionAlert, successAlertAction, errorAlertAction, showToast } =
      useDeviceMessages(props.trans);
    const localLoading = ref(false);
    const { can } = useAclUtils();

    const handleToggle = async () => {
      const result = await confirmActionAlert(props.device);

      if (!result.isConfirmed) {
        document.getElementById(`device-${props.device.id}`).checked =
          props.device.status === "ARMED";
        return;
      }

      localLoading.value = true;
      showToast(props.device.status, props.device, props.loadingToast);

      try {
        const action = props.device.status === "ARMED" ? 1 : 0;
        let urlAction = "";
        if (props.device.actions.length > 1) {
          urlAction = props.device.actions[action]?.data?.url;
        } else {
          urlAction = props.device.actions[0]?.data?.url;
        }

        await axios.get(urlAction);

        props.updateStatus();

        successAlertAction(props.device);
      } catch (error) {
        document.getElementById(`device-${props.device.id}`).checked =
          props.device.status === "ARMED";
        console.error(
          `error in request for device ${props.device.text}:`,
          JSON.stringify(error)
        );
        errorAlertAction(props.device.status, error.response?.data?.message);
      } finally {
        localLoading.value = false;
        if (props.loadingToast) props.loadingToast.close();
      }
    };

    const titleAction = (status) =>
      status === "ARMED"
        ? props.trans["dmp.deactivate"]
        : props.trans["dmp.activate"];

    const isVisible = computed(() => {
      if (can("disarm_area", "DmpPanel") && can("arm_area", "DmpPanel"))
        return true;
      if (props.device.status === "ARMED") {
        return can("disarm_area", "DmpPanel");
      } else if (props.device.status === "DISARMED") {
        return can("arm_area", "DmpPanel");
      }
    });

    const canSelectMaintenance = computed(() =>
      !!props.device.device_proxy_id &&
      (props.device.devices || []).every((zone) => !!zone.device_proxy_id)
    );

    const onMaintenanceChange = (value) => {
      if (!canSelectMaintenance.value) return;
      emit("maintenance-toggle", {
        type: "area",
        device: props.device,
        value,
      });
    };

    return {
      handleToggle,
      titleAction,
      localLoading,
      isVisible,
      onMaintenanceChange,
      canSelectMaintenance,
    };
  },
};
</script>

<style lang="scss" scoped>
.maintenance-check {
  white-space: nowrap;
  display: flex;
  align-items: center;
}
</style>
